import { Heading, TacoRating } from '@appsumo/dorado-react';

function AverageRating({ average, count }: { average: number; count: number }) {
  return (
    <div className="flex flex-col items-center justify-center gap-4 rounded border border-gravel p-3">
      {!!average && (
        <Heading.H2 className="font-header text-4xl font-bold">
          {String(average).slice(0, 3)}
        </Heading.H2>
      )}
      <div className="flex gap-x-1">
        <TacoRating averageRating={average} size="md" href="" />
        <span>{count}</span>
      </div>
    </div>
  );
}

export default AverageRating;
